import React from 'react';

import { Markdown } from '~/components/markdown/Markdown';

import WorkspaceLogo from './assets/workspace-logo.svg';
import * as S from './BotResponseCard.styles';

export interface BotResponseCardProps {
  content: string;
  actionButton?: {
    label: string;
    onClick?: () => void;
  };
}

export const BotResponseCard: React.FC<BotResponseCardProps> = ({
  content,
  actionButton,
}) => {
  return (
    <S.ResponseContainer>
      <S.Avatar>
        <WorkspaceLogo aria-label="LSEG Workspace" />
        <S.AvatarBadge />
      </S.Avatar>
      <S.Card>
        <S.Content>
          <Markdown message={content} 
          components={{
            h1: ({ children }) =>     <S.CardHeader><S.Title>{children}</S.Title></S.CardHeader>,
            p: ({ children }) => <S.Paragraph>{children}</S.Paragraph>,
          }}
          />
        </S.Content>
       { actionButton && <S.Button onClick={actionButton.onClick}>{actionButton.label}</S.Button>}
      </S.Card>
    </S.ResponseContainer>
  );
};

